module.exports = __webpack_public_path__ + "img/notice-right.cb75bb91.png";